import { MAX_WIDTH_IN_WINDOW } from "../config/page";

export function useMaxScreenWidthInClient() {
  const userAgent = navigator.userAgent;

  const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent,
  );

  return {
    isMobile,
    maxW: isMobile ? 'none' : MAX_WIDTH_IN_WINDOW
  }
}
